import store from '@/app/app-state';

export const getJobRequestDefaultParameters = () => {
  const country = store.getters['country/currentCountry'];
  const salaryOptions = store.getters['salary/getSalaryOptions'](country.value);
  const salary = [salaryOptions[0], salaryOptions[salaryOptions.length - 1]];
  return {
    country,
    salary,
  };
};

export const getJobRequestRawDataDefaultParameters = () => {
  const country = store.getters['country/currentCountry'];
  const salaryOptions = store.getters['salary/getSalaryOptions'](country.value);
  const salary = [salaryOptions[0], salaryOptions[salaryOptions.length - 1]];
  return {
    country,
    salary,
  };
};
